export const cleanupHexColors = (colors) => colors.filter((value, index, item) => {
    if (['#ffffff', '#000000'].includes(value.toLowerCase()))
        return false;
    return item.indexOf(value) === index;
});
//# sourceMappingURL=cleanupHexColors.js.map